export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 to-primary-800 rounded-lg overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">随时随地吃瓜</h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
                51每日大赛现已支持移动端访问，无论你在地铁上、午休时还是睡前刷手机，都能随时随地获取最新娱乐爆料。打开浏览器即可访问，无需下载额外应用，轻量流畅不占内存。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50 text-primary-700 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-smartphone-line mr-2"></i>
                  移动端体验
                </button>
                <button className="w-full sm:w-auto px-6 py-3 rounded-md border-2 border-primary-300/50 text-background-50 font-semibold text-sm hover:bg-primary-500/30 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-qr-code-line mr-2"></i>
                  扫码直达
                </button>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-[200px] h-[400px] rounded-lg overflow-hidden bg-background-50 border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20entertainment%20news%20feed%20with%20colorful%20gossip%20headlines%20and%20hot%20topic%20badges%2C%20warm%20red%20and%20gold%20app%20interface%2C%20modern%20UI%20design%2C%20clean%20layout%20with%20card%20based%20content%2C%20editorial%20news%20app%20aesthetic&width=400&height=800&seq=app-mockup-01&orientation=portrait"
                  alt="51每日大赛移动端体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}